import type { ICartMenuStorage } from "@/types";

const STORAGE_PREFIX = "me-qr-menu:cart:";

const EMPTY_MENU_STORAGE: ICartMenuStorage = { itemsByDishId: {} };

export const buildCartStorageKey = (menuId: number) =>
  `${STORAGE_PREFIX}${menuId}`;

export const parseCartMenuStorage = (
  raw: string | null | undefined
): ICartMenuStorage => {
  if (!raw) return EMPTY_MENU_STORAGE;

  try {
    const parsed = JSON.parse(raw) as unknown;

    if (!parsed || typeof parsed !== "object") return EMPTY_MENU_STORAGE;

    const itemsByDishId = (parsed as { itemsByDishId?: unknown }).itemsByDishId;

    if (!itemsByDishId || typeof itemsByDishId !== "object")
      return EMPTY_MENU_STORAGE;

    return {
      itemsByDishId: itemsByDishId as ICartMenuStorage["itemsByDishId"],
    };
  } catch {
    return EMPTY_MENU_STORAGE;
  }
};

export const readCartMenuStorage = (menuId: number): ICartMenuStorage => {
  const storageKey = buildCartStorageKey(menuId);
  return parseCartMenuStorage(localStorage.getItem(storageKey));
};

export const writeCartMenuStorage = (
  menuId: number,
  next: ICartMenuStorage
) => {
  const storageKey = buildCartStorageKey(menuId);
  localStorage.setItem(storageKey, JSON.stringify(next));
};
